import GoogleIcon from '@mui/icons-material/Google';
import LanguageIcon from '@mui/icons-material/Language';
import ImageIcon from '@mui/icons-material/Image';
import WeatherIcon from '@mui/icons-material/WbSunny';
import BlockIcon from '@mui/icons-material/Block';
import AutoFixHighIcon from '@mui/icons-material/AutoFixHigh';

export const tools = [
  { name: 'None (default)', icon: <BlockIcon sx={{ marginRight: 1 }} />, value: 'none', function: null },
  { name: 'Auto', icon: <AutoFixHighIcon sx={{ marginRight: 1 }} />, value: 'auto', function: { name: 'auto' } },
  { name: 'Google Search', icon: <GoogleIcon sx={{ marginRight: 1 }} />, value: 'googleSearch', function: { name: 'googleSearch' } },
  { name: 'Web Crawling', icon: <LanguageIcon sx={{ marginRight: 1 }} />, value: 'crawlAndExtractTextFromWebsite', function: { name: 'crawlAndExtractTextFromWebsite' } },
  { name: 'Image Generation', icon: <ImageIcon sx={{ marginRight: 1 }} />, value: 'generateImageResponse', function: { name: 'generateImageResponse' } },
  { name: 'Weather Forecast', icon: <WeatherIcon sx={{ marginRight: 1 }} />, value: 'generateWeatherForecastMessage', function: { name: 'generateWeatherForecastMessage' } }
];
